<template>
    <v-modal-confirmed accept-button-text="Borrar"
                       close-button-text="Cancelar"
                       title="Borrar procurador"
                       confirm-modal-accept-button-text="Sí"
                       confirm-modal-close-button-text="No"
                       confirm-modal-text="¿Estás seguro?"
                       confirm-modal-title="Confirmar..."
                       @closed="closeModal"
                       @accepted="deleteAttorney">
        <span>¿Seguro que quieres eliminar a este procurador?</span>
        <div class="user-name">{{ attorney.name + " " + attorney.surname }}</div>
    </v-modal-confirmed>
</template>

<script>
import VModalConfirmed from "../../general/VModalConfirmed";
import {deleteAttorney} from "../../../helpers/requests/RequestsAttorneys";

export default {
    name: "AttorneysListDeleteModal",
    components: {VModalConfirmed},
    props: {
        attorney: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async deleteAttorney() {
            try {
                await deleteAttorney(this.attorney);

                this.$store.dispatch('app/setToastMessage', 'Procurador eliminado');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar al procurador');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
